import React, { useState } from 'react';
import Navbar from '../../components/header/Header';
import Footer from '../../components/footer/Footer';
import sanpham from '../../api/sanpham';
import { Link } from 'react-router-dom';
import Logo from "../../images/caobangceritage.svg"
import styles from './SanPhamSearchBar.module.css';
import { FaChevronRight } from 'react-icons/fa';
import AiVoice from '../../components/AiVoice/AiVoice';
const getLoaiSanPhamOptions = () => Array.from(new Set(sanpham.map(sp => sp.loaiSanPham)));

const SanPhamPage = () => {
  const [keyword, setKeyword] = useState('');
  const [loaiSanPham, setLoaiSanPham] = useState('');

  const filtered = sanpham.filter(sp => {
    const matchKeyword = keyword.trim() ? sp.tenSanPham.toLowerCase().includes(keyword.trim().toLowerCase()) : true;
    const matchLoai = loaiSanPham ? sp.loaiSanPham === loaiSanPham : true;
    return matchKeyword && matchLoai;
  });

  return (
    <>
      <Navbar Logo={Logo}  />
      <div style={{background:'#f7f8fa', padding:'32px 0 16px 0'}}>
        <div style={{maxWidth:1600, margin:'0 auto', padding:'0 16px'}}>
          <h2 style={{marginBottom:24, fontWeight:700}}>Danh sách sản phẩm từ vải</h2>
          {/* Thanh search đẹp */}
          <div className={styles.searchBarWrapper}>
            <div className={styles.searchBar}>
              <input
                className={styles.searchInput}
                type="text"
                placeholder="Tìm kiếm sản phẩm..."
                value={keyword}
                onChange={e=>setKeyword(e.target.value)}
              />
              <select
                className={styles.select}
                value={loaiSanPham}
                onChange={e=>setLoaiSanPham(e.target.value)}
              >
                <option value="">Tất cả loại sản phẩm</option>
                {getLoaiSanPhamOptions().map(opt=>(<option key={opt} value={opt}>{opt}</option>))}
              </select>
              <button
                className={styles.clearBtn}
                onClick={()=>{setKeyword('');setLoaiSanPham('')}}
              >
                Xóa lọc
              </button>
            </div>
          </div>
          <div style={{display:'grid', gridTemplateColumns:'repeat(auto-fit, minmax(320px,1fr))', gap:32}}>
            {filtered.map((sp, idx)=>(
              <div key={sp.id} className={styles.productCard} style={{animation: `fadeInUp 0.5s ${idx*0.07}s both`}}>
                <div className={styles.imgWrapper}>
                  <img src={sp.hinhAnh[0]} alt={sp.tenSanPham} className={styles.productImg} />
                  {sp.tinhTrang === 'Mới' && <span className={styles.badgeNew}>Mới</span>}
                </div>
                <h3 className={styles.productName}>{sp.tenSanPham}</h3>
                <div className={styles.productPrice}>{typeof sp.gia === 'number' ? sp.gia.toLocaleString('vi-VN') + '₫' : sp.gia}</div>
                <Link to={`/sanpham/${sp.id}`} className={styles.detailBtn}>
                  Xem chi tiết <FaChevronRight style={{marginLeft:8}}/>
                </Link>
              </div>
            ))}
            {filtered.length === 0 && <div style={{gridColumn:'1/-1', textAlign:'center', color:'#888'}}>Không có sản phẩm phù hợp.</div>}
          </div>
        </div>
      </div>
      <AiVoice />
      <Footer />
    </>
  );
};

export default SanPhamPage; 